import actions from './sitesActions'
import mutations from './sitesMutations'

export default {
  namespaced: true,
  actions,
  mutations
}
